__webpack_require__.p = "/fingertips-dashboard/";